import { forwardRef, Inject, Injectable } from '@nestjs/common';
import { ErrorResponse, LeaveApprovalStatusEnum } from '@gtpl/shared-models/common-models';
import { AllApplyForLeavesResponse, ApplyForLeavesResponseModel, ApplyForLeavesResponseModels, ApplyForOdCoDto, ApplyForOdCoResponseModel, ApplyLeavesColumns, ApplyOdCoFilter, DtoOfRecruitmentDashboard, GetAllAvailableLeavesResponseModel } from '@gtpl/shared-models/hrms';
import { ApplyForLeavesRequest } from './dto/apply-for-leaves.request';
import { ApplyForLeavesDTO } from './dto/apply-for-leaves.dto';
import { ApplyForLeavesAdapter } from './dto/apply-for-leaves.adapter';
import { ApplyForLeaves } from './apply-for-leaves.entity';
import { GetAllAvailableLeavesDto } from './dto/get-available-leaves.dto';
import { TypesOfLeavesService } from '../types-of-leaves/types-of-leaves.service';
import { ApplyForLeavesRepository } from './repository/apply-for-leaves.repository';
import { EmployeeLeavesService } from '../employee-leaves/employee-leaves.service';
import { UpdateEmpAvlLeaves } from '../employee-leaves/dto/update-emp-consumed-leaves.dto';
import appSettings from 'apps/services/config';
import { Between, getManager, In, Repository } from 'typeorm';
import { LeaveUpdateRequest } from '../attendance/dto/leave-update.request';
import { AttendanceService } from '@gtpl/shared-services/hrms';
import { CommonResponse, RejectionReasonDto } from '@gtpl/shared-models/masters';
import { BroadCastMessageRequest } from '@gtpl/shared-models/whatsapp-broad-cast';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast'
import moment from 'moment';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { ApplyForLeavesLog } from './apply-for-leaves-log.entity';
import { EmployeeDetails } from '../../../../masters/src/app/employee-details/employee-details.entity';
import { EmployeeRepo } from '../../../../masters/src/app/employee-details/dto/employee.repository';
import { TypesOfLeavesRepository } from '../types-of-leaves/repo/types-of-leaves.repository';
import { AttendanceEntity } from '../attendance/entities/attendance.entity';
import { EmployeeLeaves } from '../employee-leaves/entity/employee-leaves.entity';
import { ApplyCoOdLeaves } from './apply-for-od-co.entity';
import { ApplyOdCoRepository } from './repository/apply-for-leaves-log.repository';
//D:\project_bmr\erpx\apps\services\hrms\src\app\apply-for-leaves\apply-for-leaves.service.ts
//D:\project_bmr\erpx\apps\services\masters\src\app\employee-details\employee-details.entity.ts
LeaveApprovalStatusEnum

@Injectable()
export class ApplyForLeavesService {

    constructor(
        private applyForLeavesRepo: ApplyForLeavesRepository,
        private applyForLeavesAdapter: ApplyForLeavesAdapter,
        private attendanceService: AttendanceService,
        private wtsAppBroadCatService: WhatsappBroadCastService,
        @Inject(forwardRef(() => EmployeeLeavesService)) private employeeLeavesService: EmployeeLeavesService,
        @Inject(forwardRef(() => TypesOfLeavesService)) private typesOfLeavesService: TypesOfLeavesService,
        private applyOdCoRepo: ApplyOdCoRepository
    ) { }

    async getApplyForLeaves(fromDate: Date): Promise<ApplyForLeaves> {
        const response = await this.applyForLeavesRepo.findOne({
            where: { fromDate: fromDate },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async createManualLeave(data: ApplyForLeavesDTO, isUpdate: boolean): Promise<ApplyForLeavesResponseModels> {
        try {
            const currDate = new Date();
            const date = currDate.getFullYear() + '-' + (Number(currDate.getMonth()) + 1) + '-' + currDate.getDate();
            if (!isUpdate) {
                const applyForLeaveEntity = await this.getApplyForLeaves(data.fromDate);
                if (applyForLeaveEntity) {
                    throw new ErrorResponse(11104, 'applyForLeave already exists');
                }
            } else {
                const applyForLeaveEntity = await this.getApplyForLeaves(data.fromDate);
                if (applyForLeaveEntity) {
                    if (applyForLeaveEntity.applyForLeavesId = data.applyForLeavesId) {
                        throw new ErrorResponse(11104, 'applyForLeave already exists');
                    }
                }
            }
            data.appliedDate = date;
            const convertedapplyForLeaveEntity: ApplyForLeaves = this.applyForLeavesAdapter.convertDtoToEntity(data, isUpdate);
            const applyForLeaves: ApplyForLeaves = await this.applyForLeavesRepo.save(convertedapplyForLeaveEntity);
            const convertedApplyForLeave: ApplyForLeavesDTO = this.applyForLeavesAdapter.convertEntityToDto(applyForLeaves);
            // updateConsumedLeaves
            const reqObj = new UpdateEmpAvlLeaves();
            reqObj.year = `${new Date(applyForLeaves.toDate).getFullYear()}`;
            reqObj.employeeId = applyForLeaves.employeeId;
            reqObj.consumedLeaves = applyForLeaves.noOfDays;
            reqObj.typeOfLeave = applyForLeaves.typeOfLeave;
            reqObj.status = LeaveApprovalStatusEnum.APPROVED
            console.log(reqObj, 'reqObjreqObjreqObjreqOb')
            await this.employeeLeavesService.updateConsumedLeaves(reqObj);

            if (convertedApplyForLeave) {
                const response = new ApplyForLeavesResponseModels(true, isUpdate ? 11100 : 11101, isUpdate ? 'applyForLeave updated successfully' : 'applyForLeave created successfully', convertedApplyForLeave);
                return response;
            } else {
                throw new ErrorResponse(11106, 'applyForLeave is saved but issue while transforming into DTO');
            }
        } catch (error) {
            throw error;
        }
    }


    async createLeave(formData: any): Promise<ApplyForLeavesResponseModel[]> {
        // console.log('Received formData:', formData);

        const transactionManager = new GenericTransactionManager();
        const responseModels: ApplyForLeavesResponseModel[] = [];

        try {
            await transactionManager.startTransaction();
            // console.log('Transaction started.');

            // Array to store errors
            const errors: { status: boolean, intlCode: number, internalMessage: string }[] = [];

            for (const data of formData.data) {
                try {
                    console.log('Processing data:', data);

                    // Check if the leave application already exists
                    const existedData = await transactionManager.getRepository(ApplyForLeaves).findOne({
                        where: {
                            employeeCode: data['Employee Code'],
                            fromDate: new Date(data['From Date']),
                            toDate: new Date(data['To Date'])
                        }
                    });

                    if (existedData) {
                        const errorMsg = `Leave application already exists for Employee Code: ${data['Employee Code']} and dates: ${data['From Date']} - ${data['To Date']}`;
                        // console.log(errorMsg);
                        errors.push({ status: false, intlCode: 0, internalMessage: errorMsg });
                        continue;
                    }

                    // Retrieve leave types
                    const getLeaveTypes = await transactionManager.getCustomRepository(TypesOfLeavesRepository)
                        .findOne({ select: ['typeOfLeaveId', 'leaveCode'], where: { typeOfLeave: data['Type Of Leave'] } });
                    if (!getLeaveTypes) {
                        const errorMsg = `Leave type not found for type: ${data['Type Of Leave']}`;
                        // console.log(errorMsg);
                        errors.push({ status: false, intlCode: 0, internalMessage: errorMsg });
                        continue;
                    }
                    console.log('Leave types retrieved:', getLeaveTypes);

                    // Retrieve employee details
                    const manager = getManager();
                    const getDataEmployeeDetails = `SELECT employee_id, employee_name FROM ${appSettings.masters_db}.employee_details WHERE employee_code = '${data['Employee Code']}'`;
                    const result = await manager.query(getDataEmployeeDetails);
                    if (result.length === 0) {
                        const errorMsg = `Employee details not found for code: ${data['Employee Code']}`;
                        // console.log(errorMsg);
                        errors.push({ status: false, intlCode: 0, internalMessage: errorMsg });
                        continue;
                    }
                    const employeeId = result[0].employee_id;
                    const employeeNames = result[0].employee_name;
                    // console.log('Employee details retrieved:', employeeId, employeeNames);

                    // Retrieve employee leaves
                    const employeeLeaves = await transactionManager.getRepository(EmployeeLeaves).findOne({
                        where: {
                            employeeId: employeeId,
                            typeOfLeave: getLeaveTypes.typeOfLeaveId
                        }
                    });

                    if (!employeeLeaves || employeeLeaves.leavesAvailable < data['No Of Days']) {
                        const errorMsg = `Employee ${data['Employee Code']} has no available leaves or not enough leaves available.`;
                        // console.log(errorMsg);
                        errors.push({ status: false, intlCode: 0, internalMessage: errorMsg });
                        continue;
                    }
                    // console.log('Employee leaves retrieved:', employeeLeaves);

                    // Check if any attendance record has presentStatus 'P' in the date range
                    const attendanceRecords = await transactionManager.getRepository(AttendanceEntity).find({
                        where: {
                            employeeId: employeeId,
                            date: Between(moment(data['From Date']).format('YYYY-MM-DD'), moment(data['To Date']).format('YYYY-MM-DD'))
                        }
                    });

                    const hasPresentStatusP = attendanceRecords.some(record => record.presentStatus === 'P');
                    if (hasPresentStatusP) {
                        const errorMsg = `Employee ${data['Employee Code']} is marked as present for the date range. Leave application cannot be created.`;
                        // console.log(errorMsg);
                        errors.push({ status: false, intlCode: 0, internalMessage: errorMsg });
                        continue;
                    }

                    // Create new leave application
                    const addObj = new ApplyForLeaves();
                    addObj.createdUser = formData.user;
                    addObj.employeeId = employeeId;
                    addObj.employeeCode = data['Employee Code'];
                    addObj.employeeName = employeeNames;
                    addObj.typeOfLeave = getLeaveTypes.typeOfLeaveId;
                    addObj.fromDate = new Date(data['From Date']);
                    addObj.toDate = new Date(data['To Date']);
                    addObj.noOfDays = data['No Of Days'];
                    addObj.leaveReason = data['Leave Reason'];
                    addObj.leaveAddress = data['Leave Address'];
                    addObj.status = LeaveApprovalStatusEnum.APPROVED;

                    // console.log('Data to be saved:', addObj);
                    const addSave = await transactionManager.getRepository(ApplyForLeaves).save(addObj);
                    if (addSave) {
                        // console.log('Leave application saved:', addSave);

                        // Update AttendanceEntity for records with presentStatus 'A'
                        await transactionManager.getRepository(AttendanceEntity).update(
                            {
                                employeeId: employeeId,
                                date: Between(moment(data['From Date']).format('YYYY-MM-DD'), moment(data['To Date']).format('YYYY-MM-DD')),
                                presentStatus: In(['A', `P/2`])
                            },
                            {
                                leaveStatus: getLeaveTypes.leaveCode,
                                reason: data['Leave Reason'],
                                presentStatus: () => `CASE 
                                WHEN present_status = 'A' THEN 'L' 
                                WHEN present_status = 'P/2' THEN 'P/L' 
                                ELSE present_status 
                                END`
                            }
                        );
                        

                        // Update EmployeeLeaves
                        // console.log('Updating employee leaves...');
                        await transactionManager.getRepository(EmployeeLeaves).update(
                            {
                                employeeId: employeeId,
                                typeOfLeave: getLeaveTypes.typeOfLeaveId,
                            },
                            {
                                leavesUsed: () => `leaves_used + ${data['No Of Days']}`,
                                leavesAvailable: () => `leaves_available - ${data['No Of Days']}`,
                            }
                        );
                    }

                    // console.log(`Leave application processed successfully for Employee Code: ${data['Employee Code']}`);
                } catch (error) {
                    const errorMsg = `Error processing leave application for Employee Code: ${data['Employee Code']}. Error: ${error.message}`;
                    // console.error('Error occurred while processing data for Employee Code:', data['Employee Code'], error);
                    errors.push({ status: false, intlCode: 0, internalMessage: errorMsg });
                }
            }

            for (const error of errors) {
                if (!error.status) {
                    responseModels.push(new ApplyForLeavesResponseModel(error.status, error.intlCode, error.internalMessage));
                }
            }
            if (responseModels.length) {
                throw responseModels
            } else {
                await transactionManager.completeTransaction();
                return [new ApplyForLeavesResponseModel(true, 1, `Leave application processed successfully for Employee Code`)];
            }
            // Push all errors outside the loop


        } catch (err) {
            // console.error('Error occurred:', err);
            await transactionManager.releaseTransaction();
            // console.log('Something went wrong');
            responseModels.push(new ApplyForLeavesResponseModel(false, 0, err.message));
            return responseModels;
        }
    }











    async getAllAppliedLeaves(): Promise<AllApplyForLeavesResponse> {
        try {
            const manager = getManager();
            let applyForLeavesDto: ApplyForLeavesDTO[] = [];
            const appplyForLeavesEntities: ApplyForLeaves[] = await this.applyForLeavesRepo.find({
                order: { createdAt: 'DESC' },
            });
            if (appplyForLeavesEntities.length > 0) {
                for (const record of appplyForLeavesEntities) {
                    const typeOfLeaveRec = await this.typesOfLeavesService.getTypesOfLeavesById(record.typeOfLeave);
                    const employeeDetails = "select employee_name as employeeName from " + appSettings.masters_db + ".employee_details where employee_id=" + record.employeeId
                    let result = await manager.query(employeeDetails)
                    const convertedDto: ApplyForLeavesDTO = this.applyForLeavesAdapter.convertEntityToDto(record);
                    convertedDto.typeOfLeaveDesc = typeOfLeaveRec.typeOfLeave;
                    convertedDto.employeeName = result[0].employeeName;
                    applyForLeavesDto.push(convertedDto);
                }
                const response = new AllApplyForLeavesResponse(true, 11208, 'ApplyForLeaves retrieved successfully', applyForLeavesDto);
                return response;
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (error) {
            throw error;
        }
    }

    async getApplyForLeavesById(id: number): Promise<ApplyForLeaves> {
        const response = await this.applyForLeavesRepo.findOne({
            where: { applyForLeavesId: id },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async activateOrDeactivateApplyForLeave(req: ApplyForLeavesRequest): Promise<ApplyForLeavesResponseModel> {
        try {
            const applyForLeaveExists = await this.getApplyForLeavesById(req.applyForLeavesId);
            if (applyForLeaveExists) {
                if (req.versionFlag != applyForLeaveExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current fromDate information. Refresh and try again');
                } else {
                    const applyForLeaveStatus = await this.applyForLeavesRepo.update(
                        { applyForLeavesId: req.applyForLeavesId },
                        { isActive: req.isActive, updatedUser: req.updatedUser }
                    );
                    if (applyForLeaveExists.isActive) {
                        if (applyForLeaveStatus.affected) {
                            const response: ApplyForLeavesResponseModel = new ApplyForLeavesResponseModel(true, 10115, 'applyForLeave is de-activated successfully');
                            return response;
                        } else {
                            throw new ErrorResponse(10111, 'applyForLeave is already de-activated');
                        }
                    } else {
                        if (applyForLeaveStatus.affected) {
                            const response: ApplyForLeavesResponseModel = new ApplyForLeavesResponseModel(true, 10114, 'applyForLeave activated successfully');
                            return response;
                        } else {
                            throw new ErrorResponse(10112, 'applyForLeave is already activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (error) {
            throw error;
        }
    }

    async updateLeaveStatus(req: ApplyForLeavesRequest): Promise<ApplyForLeavesResponseModel> {
        try {
            const applyForLeaveExists = await this.getApplyForLeavesById(req.applyForLeavesId);

            if (applyForLeaveExists) {
                if (req.versionFlag != applyForLeaveExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current fromDate information. Refresh and try again');
                } else {
                    const applyForLeaveStatus = await this.applyForLeavesRepo.update(
                        { applyForLeavesId: req.applyForLeavesId },
                        { status: req.status, updatedUser: req.updatedUser, rejectionReason: req.rejectionReason }
                    );
                    if (applyForLeaveStatus.affected) {
                        if (req.status === LeaveApprovalStatusEnum.APPROVED) {
                            const empCode = applyForLeaveExists.employeeCode;
                            const fromDate = applyForLeaveExists.fromDate;
                            const toDate = applyForLeaveExists.toDate;
                            const fromDay = applyForLeaveExists.leaveFromDay;
                            const toDay = applyForLeaveExists.leaveToDay;
                            const reqObj = new LeaveUpdateRequest(empCode, fromDate, toDate, fromDay, toDay);
                            const attnres = await this.attendanceService.updateLeave(reqObj);
                            const response: ApplyForLeavesResponseModel = new ApplyForLeavesResponseModel(true, 10114, 'Leave approved successfully');
                            return response;

                        } else if (req.status === LeaveApprovalStatusEnum.REJECTED || LeaveApprovalStatusEnum.CANCEL) {
                            const applyForLeaveData = await this.getApplyForLeavesById(req.applyForLeavesId);
                            let msg = '';
                            msg += moment().format('MMMM Do, YYYY');
                            msg += '\n';
                            const reqObj = new UpdateEmpAvlLeaves();
                            reqObj.year = `${new Date(applyForLeaveExists.toDate).getFullYear()}`;
                            reqObj.employeeId = applyForLeaveExists.employeeId;
                            reqObj.consumedLeaves = applyForLeaveExists.noOfDays;
                            reqObj.typeOfLeave = applyForLeaveExists.typeOfLeave;
                            msg += "\n Employee Code : " + applyForLeaveData.employeeCode;
                            msg += "\n"
                            msg += " Employee Name : " + applyForLeaveData.employeeName;
                            msg += "\n"
                            msg += " Reject Reason : " + applyForLeaveData.rejectionReason;

                            await this.employeeLeavesService.updateRejectedLeaves(reqObj);
                            const response: ApplyForLeavesResponseModel = new ApplyForLeavesResponseModel(true, 10114, 'Leave Rejected');
                            const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(49, msg, ['917995375316']));
                            if (messageStatus.status) {
                                return response;
                            }
                            return response;
                        }
                    } else {
                        throw new ErrorResponse(10112, 'applyForLeave is already activated');
                    }
                }
            }
        } catch (error) {
            throw (error)
        }
    }
    // /**
    //  * 
    //  * @param req 
    //  * @returns 
    //  */
    //  async getAllAvailableLeaves(req: GetAllAvailableLeavesDto): Promise<GetAllAvailableLeavesResponseModel> {
    //     const leavesConsumed = await this.applyForLeavesRepo.getAllConsumedLeaves(req);
    //     const leaves = await this.typesOfLeavesService.getTypesOfLeavesById(req.typeOfLeave);
    //     return new GetAllAvailableLeavesResponseModel(true,123,'',Number(leaves?leaves.defaultLeaves:0-leavesConsumed));
    // }

    async getAllConsumedLeavesByLeaveTypeAndEmpId(empId: number, year: string, leaveType: number): Promise<number> {
        return await this.applyForLeavesRepo.getAllConsumedLeavesByLeaveTypeAndEmpId(empId, year, leaveType);
    }




    async createOdCo(formData: any): Promise<ApplyForOdCoResponseModel[]> {
        const transactionManager = new GenericTransactionManager();
        const responseModels: ApplyForOdCoResponseModel[] = [];

        try {
            await transactionManager.startTransaction();
            const errors: { status: boolean, intlCode: number, internalMessage: string }[] = [];
            for (const data of formData.data) {
                try {
                    console.log('Processing data:', data);
                    const existedData = await transactionManager.getRepository(ApplyCoOdLeaves).findOne({
                        where: {
                            employeeCode: data['Employee Code'],
                            fromDate: new Date(data['From Date']),
                            toDate: new Date(data['To Date'])
                        }
                    });

                    if (existedData) {
                        const errorMsg = `Leave application already exists for Employee Code: ${data['Employee Code']} and dates: ${data['From Date']} - ${data['To Date']}`;
                        // console.log(errorMsg);
                        errors.push({ status: false, intlCode: 0, internalMessage: errorMsg });
                        continue;
                    }
                    const manager = getManager();
                    const getDataEmployeeDetails = `SELECT employee_id, employee_name FROM ${appSettings.masters_db}.employee_details WHERE employee_code = '${data['Employee Code']}'`;
                    const result = await manager.query(getDataEmployeeDetails);
                    if (result.length === 0) {
                        const errorMsg = `Employee details not found for code: ${data['Employee Code']}`;
                        // console.log(errorMsg);
                        errors.push({ status: false, intlCode: 0, internalMessage: errorMsg });
                        continue;
                    }
                    const employeeId = result[0].employee_id;
                    const employeeNames = result[0].employee_name;


                    // Check if any attendance record has presentStatus 'P' in the date range
                    const attendanceRecords = await transactionManager.getRepository(AttendanceEntity).find({
                        where: {
                            employeeId: employeeId,
                            date: Between(moment(data['From Date']).format('YYYY-MM-DD'), moment(data['To Date']).format('YYYY-MM-DD'))
                        }
                    });
                    console.log(attendanceRecords, 'attendanceRecordsattendanceRecords')

                    const hasPresentStatusP = attendanceRecords.some(record => record.presentStatus === 'P');
                    console.log(hasPresentStatusP, 'hasPresentStatusPhasPresentStatusP')

                    // Create new leave application
                    const addObj = new ApplyCoOdLeaves();
                    addObj.createdUser = formData.user;
                    addObj.employeeId = employeeId;
                    addObj.employeeCode = data['Employee Code'];
                    addObj.employeeName = employeeNames;
                    addObj.type = data['Type'];
                    addObj.fromDate = new Date(data['From Date']);
                    addObj.toDate = new Date(data['To Date']);
                    addObj.noOfDays = data['No Of Days'];
                    addObj.leaveReason = data['Reason'];
                    addObj.status = LeaveApprovalStatusEnum.APPROVED;
                    const addSave = await transactionManager.getRepository(ApplyCoOdLeaves).save(addObj);
                    if (addSave) {
                        await transactionManager.getRepository(AttendanceEntity).update(
                            {
                                employeeId: employeeId,
                                date: Between(moment(data['From Date']).format('YYYY-MM-DD'), moment(data['To Date']).format('YYYY-MM-DD')),

                            },
                            {
                                leaveStatus: data['Type'],
                                reason: data['Leave Reason'],
                                presentStatus: hasPresentStatusP === true ? 'P/' + data['Type'] : data['Type']
                            }
                        );
                    }
                } catch (error) {
                    const errorMsg = `Error processing leave application for Employee Code: ${data['Employee Code']}. Error: ${error.message}`;
                    errors.push({ status: false, intlCode: 0, internalMessage: errorMsg });
                }
            }

            for (const error of errors) {
                if (!error.status) {
                    responseModels.push(new ApplyForOdCoResponseModel(error.status, error.intlCode, error.internalMessage));
                }
            }
            if (responseModels.length) {
                throw responseModels
            } else {
                await transactionManager.completeTransaction();
                return [new ApplyForOdCoResponseModel(true, 1, ` successfully Uploaded`)];
            }
        } catch (err) {
            await transactionManager.releaseTransaction();
            responseModels.push(new ApplyForOdCoResponseModel(false, 0, err.message));
            return responseModels;
        }
    }


    async getCoOd(typeReq: ApplyOdCoFilter): Promise<ApplyForOdCoResponseModel> {
        console.log(typeReq, 'typeReqtypeReqtypeReq')

        try {
            let res = []
            const info = await this.applyOdCoRepo.find({where:{type:typeReq.type}});
            if (info.length > 0) {
                for (const data of info) {
                    res.push(new ApplyForOdCoDto(data.applyOdCoId,
                        data.employeeId, data.employeeCode, data.type, data.fromDate, data.toDate, data.noOfDays, data.leaveReason,
                        data.isActive, data.updatedAt, data.updatedUser, data.rejectionReason, data.createdAt, data.createdUser, data.versionFlag, data.status,
                        data.employeeName))
                }
                return new ApplyForOdCoResponseModel(true, 1, 'Data retrieved', info);
            } else {
                return new ApplyForOdCoResponseModel(false, 0, 'No data found');
            }
        } catch (err) {
            return new ApplyForOdCoResponseModel(false, 0, 'Something went wrong', err);
        }
    }
}

